import React, { Component } from "react";

import withAuth from "../../hoc/withAuth";
import MainLayout from "../../components/layouts/MainLayout";

import { uploadDocumentService } from "../../services/UploadDocumentService";

import { Form, Button, Input, Upload, Modal, Row, Col, Space, Select } from "antd";
import { EditOutlined, CloseOutlined, PlusOutlined } from "@ant-design/icons";

class UploadBpkb extends Component {
  constructor(props) {
    super(props);

    const { match } = this.props;
    const code_svb = match.params.code_svb;

    this.initState = {
      codeSVB: code_svb,
      loadingButton: false,

      editMode: false,
      editButtonText: "Edit",

      inputCategory: "motorcycle",
      inputEngineNumber: "",
      inputReason: "",

      resultObject: {},
      resultBpkbNumber: "",
      resultPlateNumber: "",
      resultEngineNumber: "",
      resultChassisNumber: "",
      resultCustomerName: "",
      resultCustomerIdNumber: "",
      resultPhoneNumber: "",
      resultEmail: "",
      resultAddress: "",
      resultCategory: "",
      resultBrandName: "",
      resultVariantCode: "",
      resultVehicleColor: "",
      resultManufactureYear: "",

      fileList: [],
      uploading: false,
      uploadedImages: [],
      resultDocumentUrl: [],
    };

    this.state = { ...this.initState };
    this.formInput = React.createRef();
  }

  handleFieldChange = (field, value) => {
    const { resultObject, editMode } = this.state;

    this.setState({ [field]: value }, () => {
      if (editMode && resultObject) {
        const fieldLabelMap = {
          resultCustomerName: "NAMA KONSUMEN",
          resultCustomerIdNumber: "NOMOR KTP KONSUMEN",
          resultPhoneNumber: "NOMOR TELEPON",
          resultEmail: "EMAIL",
          resultAddress: "ALAMAT",
          resultBpkbNumber: "NOMOR BPKB",
          resultEngineNumber: "NOMOR MESIN",
          resultPlateNumber: "NOMOR POLISI",
          resultChassisNumber: "NOMOR RANGKA",
          resultCategory: "KATEGORI",
          resultBrandName: "MEREK",
          resultVariantCode: "KODE VARIAN",
          resultVehicleColor: "WARNA KENDARAAN",
          resultManufactureYear: "TAHUN PRODUKSI",
        };

        const extractFieldMap = {
          resultCustomerName: "customer_name",
          resultCustomerIdNumber: "customer_idcard_number",
          resultAddress: "address",
          resultPhoneNumber: "phone_number",
          resultEmail: "email",
          resultBpkbNumber: "bpkb_number",
          resultPlateNumber: "plate_number",
          resultEngineNumber: "engine_number",
          resultChassisNumber: "chassis_number",
          resultCategory: "category",
          resultBrandName: "brand_name",
          resultVariantCode: "variant_code",
          resultVehicleColor: "vehicle_color",
          resultManufactureYear: "manufacture_year",
        };

        const originalValue = resultObject[extractFieldMap[field]];
        const newValue = value;

        if (originalValue !== undefined && originalValue !== newValue) {
          const label = fieldLabelMap[field] || field;
          const newReasonLine = `${label} berubah dari ${originalValue} ke ${newValue}`;

          this.setState((prevState) => {
            let updatedReason = prevState.inputReason || "";

            const regex = new RegExp(`${label} berubah dari .* ke .*`, "i");

            if (regex.test(updatedReason)) {
              // Replace line if exists
              updatedReason = updatedReason.replace(regex, newReasonLine);
            } else {
              // Append line if not exists
              updatedReason = updatedReason ? `${updatedReason}\n${newReasonLine}` : newReasonLine;
            }

            return { inputReason: updatedReason };
          });
        }
      }
    });
  };

  onExtractDokumen = async () => {
    try {
      const { inputEngineNumber, fileList } = this.state;

      if (!inputEngineNumber) {
        throw new Error("Nomor mesin wajib diisi untuk pencocokan scan");
      }

      this.setState({
        loadingButton: true,
      });

      const formData = new FormData();

      formData.append("code", inputEngineNumber);
      formData.append("document_type", "VEHICLEBPKB");

      fileList.forEach((file) => {
        formData.append("documents", file.originFileObj);
      });

      let extractedData = await uploadDocumentService.extractBpkb(formData);
      this.setState({
        loadingButton: false,
        resultObject: extractedData?.data?.data,

        resultBpkbNumber: extractedData?.data?.data?.bpkb_number,
        resultPlateNumber: extractedData?.data?.data?.plate_number,
        resultEngineNumber: extractedData?.data?.data?.engine_number,
        resultCustomerName: extractedData?.data?.data?.customer_name,
        resultCustomerIdNumber: extractedData?.data?.data?.customer_idcard_number,
        resultPhoneNumber: extractedData?.data?.data?.phone_number,
        resultEmail: extractedData?.data?.data?.email,
        resultAddress: extractedData?.data?.data?.address,
        resultCategory: extractedData?.data?.data?.category,
        resultBrandName: extractedData?.data?.data?.brand_name,
        resultChassisNumber: extractedData?.data?.data?.chassis_number,
        resultVehicleColor: extractedData?.data?.data?.vehicle_color,
        resultVariantCode: extractedData?.data?.data?.variant_code,
        resultManufactureYear: extractedData?.data?.data?.manufacture_year,
        resultDocumentUrl: extractedData?.data?.data?.document_url || [],
        inputReason: "",
        editMode: false,
      });
    } catch (error) {
      this.setState({
        loadingButton: false,
      });

      if (error.message) {
        Modal.error({
          title: "Process Error",
          content: error.message,
        });
      } else {
        Modal.error({
          title: "Process Error",
          content: "Error Timeout",
        });
      }
    }
  };

  onChangeFileList = ({ fileList }) => {
    this.setState({ fileList });
  };

  onActiveEdit = () => {
    try {
      const { resultObject } = this.state;
      if (Object.keys(resultObject).length > 0) {
        this.setState({
          editMode: true,
          inputReason: "",
        });
      } else {
        throw new Error("Dokumen belum di scan");
      }
    } catch (error) {
      this.setState({
        loadingButton: false,
      });
      Modal.error({
        title: "Process Error",
        content: error.message,
      });
    }
  };

  onCancelEdit = () => {
    const { resultObject } = this.state;

    this.setState({
      editMode: false,
      resultBpkbNumber: resultObject?.bpkb_number,
      resultPlateNumber: resultObject?.plate_number,
      resultEngineNumber: resultObject?.engine_number,
      resultCustomerName: resultObject?.customer_name,
      resultCustomerIdNumber: resultObject?.customer_idcard_number,
      resultPhoneNumber: resultObject?.phone_number,
      resultEmail: resultObject?.email,
      resultAddress: resultObject?.address,
      resultCategory: resultObject?.category,
      resultBrandName: resultObject?.brand_name,
      resultChassisNumber: resultObject?.chassis_number,
      resultVehicleColor: resultObject?.vehicle_color,
      resultVariantCode: resultObject?.variant_code,
      resultManufactureYear: resultObject?.manufacture_year,
      inputReason: "",
    });
  };

  onSaveData = async () => {
    try {
      const { ...currentState } = this.state;

      if (Object.keys(currentState.resultObject).length < 1) {
        throw new Error("Belum mengextract data");
      }

      if (!currentState.resultBpkbNumber) {
        throw new Error("Nomor BPKB tidak valid");
      }
      if (!currentState.resultPlateNumber) {
        throw new Error("Nomor Polisi tidak valid");
      }
      if (!currentState.resultEngineNumber) {
        throw new Error("Nomor Mesin tidak valid");
      }
      if (!currentState.resultCustomerName) {
        throw new Error("Nama Konsumen tidak valid");
      }
      if (!currentState.resultCustomerIdNumber) {
        throw new Error("Nomor KTP Konsumen  tidak valid");
      }

      if (currentState.editMode === true && !currentState.inputReason) {
        throw new Error("Alasan tidak valid");
      }

      const payload = {
        bpkb_number: currentState.resultBpkbNumber,
        plate_number: currentState.resultPlateNumber,
        engine_number: currentState.resultEngineNumber,
        chassis_number: currentState.resultChassisNumber,
        customer_name: currentState.resultCustomerName,
        customer_idcard_number: currentState.resultCustomerIdNumber,
        address: currentState.resultAddress,
        phone_number: currentState.resultPhoneNumber,
        email: currentState.resultEmail || null,
        category: currentState.resultCategory,
        brand_name: currentState.resultBrandName,
        variant_code: currentState.resultVariantCode,
        vehicle_color: currentState.resultVehicleColor,
        manufacture_year: currentState.resultManufactureYear,
        edit_mode: currentState.editMode,
        edit_reason: currentState.inputReason || "",
        document_url: currentState.resultDocumentUrl || [],
      };

      this.setState({
        loadingButton: true,
      });

      await uploadDocumentService.uploadBpkb(payload).then(async (data) => {
        Modal.success({
          title: "Process Success",
          content: "SUCCESS",
        });

        this.setState(this.initState);
      });
    } catch (error) {
      this.setState({
        loadingButton: false,
      });
      Modal.error({
        title: "Process Error",
        content: error.message,
      });
    }
  };

  getYears = (lastXyear = 5) => {
    const currentYear = new Date().getFullYear();
    return Array.from({ length: lastXyear }, (v, i) => currentYear - i);
  };

  render() {
    const {
      fileList,
      uploading,
      loadingButton,
      // inputCategory,
      inputEngineNumber,
      resultBpkbNumber,
      resultPlateNumber,
      resultVehicleColor,
      resultEngineNumber,
      resultChassisNumber,
      resultCustomerName,
      resultCustomerIdNumber,
      resultPhoneNumber,
      resultEmail,
      resultAddress,
      resultCategory,
      resultBrandName,
      resultVariantCode,
      resultManufactureYear,
      editMode,
      inputReason,
    } = this.state;

    return (
      <React.Fragment>
        <MainLayout defaultOpenKeys={["7dokumen"]} defaultSelectedKeys={["13uploadbpkb"]}>
          <div style={{ padding: 10, margin: 10, background: "#FFF" }}>
            <Form ref={this.formInput} name="form-filter" layout="vertical">
              <Row>
                <Col>
                  <Row>
                    {/* <Col style={{ paddingLeft: 5, paddingRight: 5 }}>
                      <Form.Item label="Kategori">
                        <Input type="hidden" value={inputCategory} onChange={(event) => this.handleFieldChange("inputCategory", event.target.value)} disabled />
                      </Form.Item>
                    </Col> */}
                    <Col style={{ paddingLeft: 5, paddingRight: 5 }}>
                      <Form.Item label="Nomor Mesin">
                        <Input placeholder="Masukkan Nomor Mesin" style={{ width: 200 }} onChange={(event) => this.handleFieldChange("inputEngineNumber", event.target.value)} value={inputEngineNumber} />
                      </Form.Item>
                    </Col>
                    <Col style={{ paddingLeft: 5, paddingRight: 5 }}>
                      <Form.Item label="&nbsp;">
                        <Button type="primary" onClick={this.onExtractDokumen} disabled={fileList.length === 0} loading={loadingButton} style={{ background: "#1784b8", borderColor: "#1784b8" }}>
                          {uploading ? "Uploading" : "Extract Images"}
                        </Button>
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col style={{ paddingLeft: 5, paddingRight: 5 }} xs={{ span: 24 }} xl={{ span: 8 }} lg={{ span: 8 }} md={{ span: 12 }} sm={{ span: 24 }}>
                  <strong>Upload Dokumen</strong>
                  <hr />

                  <Space.Compact>
                    <Upload
                      multiple
                      listType="picture-card"
                      fileList={fileList}
                      onChange={this.onChangeFileList}
                      beforeUpload={() => false} // Prevent auto upload
                      accept="image/*,.pdf"
                    >
                      <span>
                        <PlusOutlined />
                        <br />
                        <strong>Upload</strong>
                      </span>
                    </Upload>
                  </Space.Compact>
                </Col>
                <Col style={{ paddingLeft: 5, paddingRight: 5 }} xs={{ span: 24 }} xl={{ span: 16 }} lg={{ span: 16 }} md={{ span: 12 }} sm={{ span: 24 }}>
                  <strong>Hasil Extract Dokumen</strong>
                  <hr />
                  <Row>
                    <Col style={{ paddingLeft: 5, paddingRight: 5 }} xs={{ span: 24 }} xl={{ span: 8 }} lg={{ span: 8 }} md={{ span: 10 }} sm={{ span: 24 }}>
                      <Form.Item label="Nama Konsumen">
                        <Input value={resultCustomerName} onChange={(event) => this.handleFieldChange("resultCustomerName", event.target.value)} disabled={!editMode} />
                      </Form.Item>
                      <Form.Item label="Nomor KTP Konsumen">
                        <Input value={resultCustomerIdNumber} onChange={(event) => this.handleFieldChange("resultCustomerIdNumber", event.target.value)} disabled={!editMode} />
                      </Form.Item>
                      <Form.Item label="Nomor Telepon">
                        <Input value={resultPhoneNumber} onChange={(event) => this.handleFieldChange("resultPhoneNumber", event.target.value)} disabled={!editMode} />
                      </Form.Item>
                      <Form.Item label="Email">
                        <Input value={resultEmail} onChange={(event) => this.handleFieldChange("resultEmail", event.target.value)} disabled={!editMode} />
                      </Form.Item>
                      <Form.Item label="Alamat">
                        <Input.TextArea onChange={(event) => this.handleFieldChange("resultAddress", event.target.value)} disabled={!editMode} value={resultAddress} />
                      </Form.Item>
                    </Col>
                    <Col style={{ paddingLeft: 5, paddingRight: 5 }} xs={{ span: 24 }} xl={{ span: 16 }} lg={{ span: 16 }} md={{ span: 14 }} sm={{ span: 24 }}>
                      <Row>
                        <Col style={{ paddingLeft: 5, paddingRight: 5 }} xs={{ span: 24 }} xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }}>
                          <Form.Item label="No BPKB">
                            <Input value={resultBpkbNumber} onChange={(event) => this.handleFieldChange("resultBpkbNumber", event.target.value)} disabled={!editMode} />
                          </Form.Item>
                        </Col>
                        <Col style={{ paddingLeft: 5, paddingRight: 5 }} xs={{ span: 24 }} xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }}>
                          <Form.Item label="Nomor Polisi">
                            <Input value={resultPlateNumber} onChange={(event) => this.handleFieldChange("resultPlateNumber", event.target.value)} disabled={!editMode} />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row>
                        <Col style={{ paddingLeft: 5, paddingRight: 5 }} xs={{ span: 24 }} xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }}>
                          <Form.Item label="Nomor Mesin">
                            <Input value={resultEngineNumber} onChange={(event) => this.handleFieldChange("resultEngineNumber", event.target.value)} disabled={!editMode} />
                          </Form.Item>
                        </Col>
                        <Col style={{ paddingLeft: 5, paddingRight: 5 }} xs={{ span: 24 }} xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }}>
                          <Form.Item label="Nomor Rangka">
                            <Input value={resultChassisNumber} onChange={(event) => this.handleFieldChange("resultChassisNumber", event.target.value)} disabled={!editMode} />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row>
                        <Col style={{ paddingLeft: 5, paddingRight: 5 }} xs={{ span: 24 }} xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }}>
                          <Form.Item label="Kategori Kendaraan">
                            <Input value={resultCategory} onChange={(event) => this.handleFieldChange("resultCategory", event.target.value)} disabled={!editMode} />
                          </Form.Item>
                        </Col>
                        <Col style={{ paddingLeft: 5, paddingRight: 5 }} xs={{ span: 24 }} xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }}>
                          <Form.Item label="Merk Kendaraan">
                            <Input value={resultBrandName} onChange={(event) => this.handleFieldChange("resultBrandName", event.target.value)} disabled={!editMode} />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row>
                        <Col style={{ paddingLeft: 5, paddingRight: 5 }} xs={{ span: 24 }} xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }}>
                          <Form.Item label="Variant Kendaraan">
                            <Input value={resultVariantCode} onChange={(event) => this.handleFieldChange("resultVariantCode", event.target.value)} disabled={!editMode} />
                          </Form.Item>
                        </Col>
                        <Col style={{ paddingLeft: 5, paddingRight: 5 }} xs={{ span: 24 }} xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }}>
                          <Form.Item label="Warna Kendaraan">
                            <Input value={resultVehicleColor} onChange={(event) => this.handleFieldChange("resultVehicleColor", event.target.value)} disabled={!editMode} />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row>
                        <Col style={{ paddingLeft: 5, paddingRight: 5 }} xs={{ span: 24 }} xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }}>
                          <Form.Item label="Alasan Pengeditan">
                            <Input.TextArea rows={5} onChange={(event) => this.handleFieldChange("inputReason", event.target.value)} disabled={true} value={inputReason} />
                          </Form.Item>
                        </Col>
                        <Col style={{ paddingLeft: 5, paddingRight: 5 }} xs={{ span: 24 }} xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }}>
                          <Form.Item label="Tahun Kendaraan">
                            <Input value={resultManufactureYear} onChange={(event) => this.handleFieldChange("resultManufactureYear", event.target.value)} disabled={!editMode} />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row>
                    <Col style={{ paddingLeft: 5, paddingRight: 5 }}>
                      <Button onClick={() => this.onActiveEdit()} type="primary" icon={<EditOutlined />} style={{ background: "#ca2e2e", borderColor: "#ca2e2e", display: this.state.editMode ? "none" : "block" }} loading={this.state.loadingButton}>
                        Edit Data
                      </Button>
                      <Button onClick={() => this.onCancelEdit()} type="primary" icon={<CloseOutlined />} style={{ background: "#ca2e2e", borderColor: "#ca2e2e", display: this.state.editMode ? "block" : "none" }} loading={this.state.loadingButton}>
                        Batal Edit
                      </Button>
                    </Col>
                    <Col style={{ paddingLeft: 5, paddingRight: 5 }}>
                      <Button type="primary" onClick={this.onSaveData} loading={loadingButton} style={{ background: "#1784b8", borderColor: "#1784b8" }}>
                        Simpan Dokumen
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Form>
          </div>
        </MainLayout>
      </React.Fragment>
    );
  }
}

export default withAuth(UploadBpkb);
